import { Component, ChangeDetectionStrategy} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-selection-cell',
    template: `<p-checkbox [binary]="true" [(ngModel)]="value" (onChange)="onChange()" [disabled]="isDisabled"></p-checkbox>`,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SelectionCellComponent implements AgRendererComponent {
    params: any;
    value: boolean = true;
    isDisabled: boolean = false;

    constructor() {}

    agInit(params: any) {
        this.params = params;
        this.value = this.params.node.isSelected();
        this.isDisabled = typeof this.params.data.isDisabled === 'boolean' ? this.params.data.isDisabled : false;
    }

    refresh(params: any): boolean {
        this.params = params;
        
        if(this.value !== this.params.node.isSelected()) {
            this.value = this.params.node.isSelected();
        }
        
        return true;
    }

    onChange() {
        if (!this.isDisabled) {
            this.value = !this.value;
        }
    }
}
